module.exports = __webpack_public_path__ + "img/banner.e76f22d7.png";